export const setTipsSettings = value => ({
    type: 'SET_TIPS_SETTINGS',
    value
});